<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">添加日常用药</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body" style="height: 400px;">
        <el-form :model="addForm" :rules="rules" ref="addForm">
          <div>
            <el-row>
              <el-col :span="12" class="item">
                <el-form-item label="药品" prop="drugName">
                  <el-input v-model="addForm.drugName" placeholder="请输入药品名称"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12" class="item">
                <el-form-item label="服用开始日期" required prop="beginTime">
                  <el-date-picker value-format="yyyy-MM-dd" v-model="addForm.beginTime" style="width: 100%"
                                  type="date" placeholder="选择日期"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12" class="item">
                <el-form-item label="服用结束日期" required prop="endTime">
                  <el-date-picker value-format="yyyy-MM-dd" v-model="addForm.endTime"  style="width: 100%"
                                  type="date" placeholder="选择日期"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12" class="item">
                <el-form-item label="用药剂量" required prop="dosage">
                  <el-input v-model="addForm.dosage" placeholder="请输入用药剂量"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" class="item">
                <el-form-item label="使用疗程" required prop="treatment">
                  <el-input v-model="addForm.treatment" placeholder="请输入"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12" class="item">
                <el-form-item label="使用方法" required prop="takeMethod">
                  <el-input v-model="addForm.takeMethod" placeholder="请输入使用方法"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="24" class="item">
                <el-form-item label="对应疾病或临床表现" required prop="remarks">
                  <el-input v-model="addForm.remarks" placeholder="输入"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>
      </div>
      <div class="modal-footer">
        <el-button :loading="loading" type="primary" @click="confirm('addForm')">添加</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { timeStr } from "@/common/times";
import { hex_md5 } from "@/common/Base64MD5";
import { getStaffCode } from "@/utils/auth";


export default {
  name: "Add",
  data() {
    return {
      loading: false,

      addForm: {
        timeStr: timeStr,
        staffCode: getStaffCode(),
        sign: "",
        userCode: "",
        elderlyCode: "",
        drugName: "",
        beginTime: "",
        endTime: "",
        dosage: "",
        treatment: "",
        takeMethod: "",
        remarks: "",
      },

      rules: {
        drugName: [
          { required: true, message: "请输入药品名称", trigger: "blur" },
        ],
        beginTime: [
          { required: true, message: "请选择开始时间", trigger: "blur" },
        ],
        endTime: [
          { required: true, message: "请输入结束时间", trigger: "blur" },
        ],
        dosage: [
          { required: true, message: "请输入用药剂量", trigger: "blur" },
        ],
        treatment: [
          { required: true, message: "请输入使用疗程", trigger: "blur" },
        ],
        takeMethod: [
          { required: true, message: "请输入使用方法", trigger: "blur" },
        ],
        remarks: [{ required: true, message: "请输入作用", trigger: "blur" }],
      },

    };
  },

  components: {

  },

  methods: {
    init(elderlyCode, userCode) {
      this.$refs.addForm.resetFields();
      this.addForm.elderlyCode = elderlyCode;
      this.addForm.userCode = userCode;
    },
    closeSelf() {
      this.$emit("closeAdd");
    },

    confirm(addForm) {
      this.$refs[addForm].validate((valid) => {
        if (valid) {
          this.addSubmit();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    addSubmit() {
      if (this.loading) {
        return;
      } else {
        this.loading = true;
      }
      this.addForm.sign = hex_md5(
        "timeStr=" + timeStr + "&key=" + this.$signKey
      );
      this.$axios({
        method: "post",
        url: this.$shopUrl + "ETakeDrugs/Add",
        data: this.addForm,
      }).then((response) => {
        this.loading = false;
        if (response.data.error == 0) {
          this.$emit("closeAdd");
          this.$emit("getList", true);
        } else if (response.data.error == 1) {
          this.$message.error(response.data.message);
        }
      });
    },


  },
};
</script>


<style lang="scss" scoped>

</style>
